import { Controller } from "remult";

@Controller("call-center-volunteer-methods")
export class CallCenterVolunteerMethods {}
